import * as React from 'react';
import { convertIcon } from '../components/Icon';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12C3.5 7.58173 7.08173 4 11.5 4C13.7094 4 15.7081 4.89435 17.1568 6.34316C17.4361 6.62246 17.8399 7.05385 18.2497 7.5H16C15.4477 7.5 15 7.94772 15 8.5C15 9.05228 15.4477 9.5 16 9.5H20.5C21.0523 9.5 21.5 9.05228 21.5 8.5V4C21.5 3.44772 21.0523 3 20.5 3C19.9477 3 19.5 3.44772 19.5 4V5.90549C19.1565 5.53424 18.8233 5.18114 18.5711 4.92895C16.7625 3.12038 14.2612 2 11.5 2C5.97717 2 1.5 6.47717 1.5 12C1.5 17.5228 5.97717 22 11.5 22C14.2612 22 16.7625 20.8796 18.5711 19.071C18.9616 18.6805 18.9616 18.0474 18.571 17.6568C18.1805 17.2663 17.5474 17.2663 17.1568 17.6569C15.7081 19.1057 13.7094 20 11.5 20C7.08173 20 3.5 16.4183 3.5 12Z",
    fill: "currentColor"
  }));
}
const IconComponent = convertIcon(SvgComponent, 'redo_stroked');
export default IconComponent;